import axios from "axios";

export default async function SubmitFilter(projectName, data){
    return await axios.post(`/project/${projectName}/submit-query`, data)
}